'use es6';

export const MAC = 'MAC';
export const WINDOWS = 'WINDOWS';